import { Link } from "react-router-dom";
import { logo } from "constants/Images";
import React, { useState } from "react";
import LanguageSwitcher from "./LanguageSwitcher";

import { useTranslation } from "react-i18next";

function Navbar(props) {
  const { t } = useTranslation(["navbar"]);
  const [activeLink, setActiveLink] = useState("home");

  const handleNavClick = (sectionId) => {
    let offset = 0;
    if (sectionId == "home") {
      offset = 0;
    }

    setActiveLink(sectionId);

    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = offset || -70; // Adjust this value to set the scroll position
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      {/* <h1>{t("translation:welcome_message")}</h1> */}
      {/* <h1>{t("factoryData", { ns: "navbar" })}</h1> */}

      <nav className="navbar navbar-expand-lg navbar-light bg-body-tertiary">
        <div className="container">
          <img src={logo} className="navbar-logo" />
          <button
            data-mdb-collapse-init
            className="navbar-toggler"
            type="button"
            data-bs-target="#navbarNavAltMarkup"
            aria-bs-controls="navbarNavAltMarkup"
            aria-bs-expanded="false"
            aria-bs-label="Toggle navigation"
            data-bs-toggle="collapse"
            // data-bs-target=".navbarNav"
            // aria-controls="navbarNav"
            // aria-expanded="false"
            // aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <LanguageSwitcher />
            <div className="navbar-nav d-lg-flex d-grid row-gap-2 justify-content-center">
              <Link
                className={`nav-link text-center me-3  home ${
                  activeLink === "home" ? "active" : ""
                }`}
                aria-current="page"
                href="#home"
                onClick={() => handleNavClick("home")}
              >
                {t("home", { ns: "navbar" })}
              </Link>
              <Link
                className={`nav-link text-center me-3   ${
                  activeLink === "AboutUs" ? "active" : ""
                }`}
                onClick={() => handleNavClick("AboutUs")}
                href="#AboutUs"
              >
                {t("aboutUs", { ns: "navbar" })}
              </Link>
              <Link
                className={`nav-link text-center me-3 
            ${activeLink === "products" ? "active" : ""}`}
                onClick={() => handleNavClick("products")}
                href="#products"
              >
                {t("products", { ns: "navbar" })}
              </Link>
              <Link
                className={`nav-link text-center    ${
                  activeLink === "contactUs" ? "active" : ""
                }`}
                onClick={() => handleNavClick("contactUs")}
                href="#contactUs"
              >
                {t("contactUs", { ns: "navbar" })}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div id="home" className="hero">
        <div className="row w-100 h-100 o px-5">
          <div className="col-xxl-6  col-xl-6 col-lg-7 col-md-8 col-12">
            <div className="d-flex justify-content-center align-items-center h-100">
              <p className="hero-title text-white text-center fs-md-34">
                {t("HeroTitle", { ns: "navbar" })}

                {/* Color Your World: Bring Your Vision to Life with Our Premium Product Paints. */}

                {/* Color Your World: Transform Your Home with Your Favorite Shades */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
